// imported libraries needed
import React from 'react'
import Header from './Header';
import Form from './Form';




const Home = () =>{
  return (
    <main>
    <Header />
    <Form />
    </main>
  )
}
export default Home;
